import { type FC, type ReactNode } from 'react';
import { CardContent } from '@mui/material';

interface CustomCardContentProps {
  id: string;
  className?: string;
  children?: ReactNode;
}

const CustomCardContent: FC<CustomCardContentProps> = ({
  id,
  className,
  children,
}) => {
  return (
    <CardContent id={`card-content-${id}`} className={className}>
      {children}
    </CardContent>
  );
};

export default CustomCardContent;
